"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
exports.__esModule = true;
var React = require("react");
var utils_1 = require("../utils");
var RectShape = function RectShape(_a) {
  var className = _a.className,
    style = _a.style,
    color = _a.color;
  var defaultStyle = {
    backgroundColor: color,
    width: '100%',
    height: '100%',
    marginRight: 10
  };
  return React.createElement("div", {
    className: utils_1.joinClassNames('rect-shape', className),
    style: __assign(__assign({}, defaultStyle), style)
  });
};
exports["default"] = RectShape;